<template>
    <Modal :show="show" :max-width="'2xl'" class="flex flex-col max-h-[90vh] gap-px" @close="close">
        <div v-if="loading.info" class="py-10 text-center">
            {{ lang('media::media.messages.loading') }}
        </div>
        <GalleryDetail v-else :item="detail" @updated="updated" @close="close" />
    </Modal>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import GalleryDetail from './GalleryDetail.vue';

const emit = defineEmits<{
    (event: 'close'): void;
    (event: 'updated', item: any): void;
}>();

interface Props {
    show?: boolean;
    item: any;
    multiple?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    show: true,
    selected: null,
    multiple: false,
});

const loading = ref({
    info: false,
});

const item = ref(props.item);
const show = ref(props.show);
const detail = ref(null);

const loadInfo = () => {
    loading.value.info = true;
    axios.get(route('media.admin.api.media.info', { id: item.value.id })).then(({ data }) => {
        detail.value = data;
        loading.value.info = false;
    });
};

const close = () => {
    show.value = false;
    emit('close');
};

const updated = (value) => {
    emit('updated', value);
};

watch(
    () => props.item,
    (value) => {
        item.value = value;
    },
);

watch(
    () => show.value,
    (value) => {
        if (value) {
            loadInfo();
        }
    },
    { immediate: true },
);
</script>
